module.exports = __webpack_public_path__ + "img/title-logo.54e61940.png";